<!-- The ref attr used to find the swiper instance -->
<template>
  <!--首页banner-->
  <section class="swiper-content" v-if="list && list.length > 0">
    <swiper
      :options="swiperOption"
      :not-next-tick="notNextTick"
      ref="mySwiper"
      @click.native="slideClickHandle"
    >
      <swiper-slide
        v-if="item.pic"
        v-for="(item, index) in list"
        :data-url="item.url"
        :data-key="index + 1"
        :key="index"
      >
        <img
          v-if="propsData && propsData.length > 0"
          :src="item.pic"
          :onerror="defaultLogo"
          :alt="item.desc"
        />
        <img v-else :src="cosPrefix + item.pic" :onerror="defaultLogo" :alt="item.desc" />
      </swiper-slide>
      <!--空数据时展示默认图片-->
      <swiper-slide v-if="loadDone && slideLength < 1">
        <img src="../../assets/images/default_banner.png" :onerror="defaultLogo" />
      </swiper-slide>
      <!--轮播数量大于1时才显示导航-->
      <div class="swiper-pagination" slot="pagination" v-show="loadDone && slideLength > 1"></div>
    </swiper>
  </section>
</template>

<script>
import { jumpLink, MtaH5ClickStat } from "@/assets/js/util";
import { swiper, swiperSlide } from "vue-awesome-swiper";

require("swiper/dist/css/swiper.css");

export default {
  name: "carrousel1",
  components: {
    swiper,
    swiperSlide
  },
  props: {
    list: {
      default: function() {
        return [];
      }
    },
    eventId: {
      default: "daishuUsercenterBanner"
    }
  },
  data() {
    return {
      cosPrefix: cos_prefix,
      broswerType: BROSWER_TYPE,
      defaultLogo: `this.src="${require("@/assets/images/default-banner-1.png")}"`, // 套餐图片显示错误时展示的默认图片
      loadDone: false,
      // NotNextTick is a component's own property, and if notNextTick is set to true, the component will not instantiate the swiper through NextTick, which means you can get the swiper object the first time (if you need to use the get swiper object to do what Things, then this property must be true)
      // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
      notNextTick: true,
      swiperOption: {
        // swiper options 所有的配置同swiper官方api配置
        initialSlide: 0, // 初始显示第几张图
        // autoplay: true,
        autoplay: {
          delay: 3000, //秒
          stopOnLastSlide: false,
          disableOnInteraction: false //滑动不会失效
        },
        loop: true,
        autoplayDisableOnInteraction: false,
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        // paginationClickable: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      slideLength: 0,
      propsData: []
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper && this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    // 到优惠券领取页面
    toCoupon(item) {
      window.location.href = item.url;
    },
    // 处理点击事件
    slideClickHandle() {
      let curSlide = $(this.$refs.mySwiper.$el).find(".swiper-slide-active");

      // 埋点
      if (this.eventId) {
        let obj = {};
        let key = "banner" + curSlide.attr("data-key");
        obj[key] = "true";
        MtaH5ClickStat(obj, this.eventId);
      }
      // 判断是否是本地路由url，是则跳转至本地路由，否则正常跳转
      jumpLink({
        vm: this,
        url: curSlide.attr("data-url"),
        isReplaceRouter: false
      });
    },
    pushData(data) {
      this.nextTick(() => {
        this.list = this.propsData = data;
        // 轮播图小于2两张时，锁定轮播图
        if (this.list.length < 2) {
          this.swiper.allowSlideNext = false;
        } else {
          this.swiper.allowSlideNext = true;
        }
        this.swiper.update();
      }, 100);
    }
  },
  watch: {
    list(data) {
      if (data.length > 0) {
        setTimeout(() => {
          this.slideLength = data.length;
          // 轮播图小于2两张时，锁定轮播图
          this.loadDone = true;
          if (this.slideLength < 2) {
            this.swiper.allowSlideNext = false;
          } else {
            this.swiper.allowSlideNext = true;
          }
          this.swiper && this.swiper.update();
        }, 100);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/swiper-3.4.2.min.css";
@image: "../assets/images/";
.swiper-content {
  position: relative;
  width: 688/200rem;
  height: 274/200rem;
  margin: 0 auto;
}
.swiper-container {
  width: 100%;
  height: 274/200rem;
  overflow: hidden;
  border-radius: 20/200rem;
  box-shadow: 0 8/200rem 18/200rem 0 rgba(0, 0, 0, 0.14);

  .swiper-wrapper {
    .swiper-slide {
      width: 100%;
      height: 276/200rem;

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
  }
  .swiper-pagination {
    bottom: 10/200rem;
    /deep/ .swiper-pagination-bullet {
      width: 5px;
      height: 5px;
      background: #fff;
      opacity: 0.7;

      &.swiper-pagination-bullet-active {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        opacity: 1;
        background: @color-theme;
      }
    }
  }
}
</style>
